import { render, staticRenderFns } from "./customer-stage.vue?vue&type=template&id=2ef46c0a&scoped=true&"
import script from "./customer-stage.vue?vue&type=script&lang=js&"
export * from "./customer-stage.vue?vue&type=script&lang=js&"
import style0 from "./customer-stage.vue?vue&type=style&index=0&id=2ef46c0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef46c0a",
  null
  
)

export default component.exports